import { stats } from '@fiverr-private/obs';
import { METRICS_PREFIX } from '../constants';

export const retryWrapper = async <T>({
    retries,
    wrappedFn,
    metric,
    abortController,
}: {
    retries: number;
    wrappedFn: () => Promise<T>;
    metric?: string;
    abortController?: AbortController;
}): Promise<T | undefined> => {
    for (let attempt = 0; attempt <= retries; attempt++) {
        if (abortController?.signal.aborted) {
            throw new Error('Request was aborted');
        }

        try {
            return await wrappedFn();
        } catch (error) {
            if (abortController?.signal.aborted) {
                throw error;
            }

            if (attempt === retries) {
                throw error;
            }

            if (metric) {
                stats.count(`${METRICS_PREFIX}.${metric}`, 'retry');
            }
        }
    }
};
